import styles from './ScoresheetSkeleton.module.css';

export function ScoresheetSkeleton() {
  return <div className={styles.scoresheet_skeleton} />;
}
